import ThemedComponent from '../../hoc/ThemedComponent';

import { default as StreamTDSFormViewDefault } from './StreamTDSForm/View';
import { default as StreamTDSFormView3} from '../../themes/3/components/StreamTDS/StreamTDSForm';

const ThemedStreamTDSForm = {
  default: StreamTDSFormViewDefault,
  // 3: StreamTDSFormView3,
};

export const StreamTDSFormView = ThemedComponent(ThemedStreamTDSForm);